import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaExternalLinkAlt } from "react-icons/fa";
import { loadStoreSettings } from "../../util/storeSettings";

function pageTitle(pathname) {
  if (/^\/admin\/orders\/[^/]+/.test(pathname)) return "Order";
  if (/^\/admin\/edit-product\//.test(pathname)) return "Edit product";
  if (/^\/admin\/edit-category\//.test(pathname)) return "Edit category";
  if (/^\/admin\/invoice-details\//.test(pathname)) return "Invoice";
  if (/^\/admin\/refund-order-details\//.test(pathname)) return "Refund";

  const titles = {
    "/admin/dashboard": "Dashboard",
    "/admin/orders": "Orders",
    "/admin/products": "Products",
    "/admin/view-product": "Products",
    "/admin/add-product": "Add product",
    "/admin/categories": "Categories",
    "/admin/view-category": "Categories",
    "/admin/shopify-import": "Shopify import",
    "/admin/add-category": "Add category",
    "/admin/inventory": "Inventory",
    "/admin/customers": "Customers",
    "/admin/users": "Customers",
    "/admin/coupons": "Coupons",
    "/admin/discount": "Discounts",
    "/admin/discounts": "Discounts",
    "/admin/reviews": "Reviews",
    "/admin/seo": "SEO audit",
    "/admin/seo/search-console": "Search Console",
    "/admin/reports": "Reports",
    "/admin/analytics": "Reports",
    "/admin/ledger": "Ledger",
    "/admin/chart_of_account": "Money",
    "/admin/couriers": "Couriers",
    "/admin/payments": "Payments",
    "/admin/policies": "Policies",
    "/admin/settings": "Settings",
    "/admin/backup": "Backup",
    "/admin/themes": "Themes",
    "/admin/invoice": "Sales",
    "/admin/sales": "Sales",
    "/admin/show-sales": "Sales",
    "/admin/refundView": "Refunds",
    "/admin/profile": "Profile",
  };

  return titles[pathname] || "Admin";
}

export default function Navbar({ onMenu }) {
  const location = useLocation();
  const authName = sessionStorage.getItem("auth_name") || "Administrator";
  const [storeName, setStoreName] = useState("Store");

  useEffect(() => {
    let active = true;
    loadStoreSettings().then((settings) => {
      if (active && settings && settings.storeName) setStoreName(settings.storeName);
    }).catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const initial = authName.trim().charAt(0).toUpperCase() || "A";

  return (
    <header className="admin-topbar">
      <button type="button" className="admin-menu-btn" aria-label="Open menu" onClick={onMenu}>
        <FaBars size={16} />
      </button>
      <div className="admin-topbar-title">
        <span className="admin-topbar-kicker">{storeName}</span>
        <h4>{pageTitle(location.pathname)}</h4>
      </div>

      <div className="admin-topbar-actions">
        <Link
          to="/"
          target="_blank"
          rel="noreferrer"
          className="admin-store-btn"
          title="Open the store"
        >
          <FaExternalLinkAlt size={11} />
          <span>View store</span>
        </Link>

        <div className="admin-user-pill">
          <div className="admin-user-avatar" aria-hidden="true">{initial}</div>
          <span className="admin-user-name">{authName}</span>
        </div>
      </div>
    </header>
  );
}
